export { isAuthorMode } from "./isAuthorMode";
